module.exports = __webpack_public_path__ + "static/media/nft.0822536a.png";